/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Prashant R. Mohta',
        title: 'Testbook',
        text: "Vaibhav joined us as an associate a frontend developer intern. He is passionate, creative and always keen on learning new things.",
        image: boy1
    },
    {
        id: 2,
        name: 'Siddarth Kandola',
        title: 'Testbook',
        text: "Vaibhav started as an frontend developer. His erg of learning and developing new skills is exemptional.",
        image: boy2
    },
    {
        id: 3,
        name: 'Harsh Shrivastava',
        title: 'Coditas',
        text: "Vaibhav has joined us as an associate software engineering intern. He is hardworking, focused and dedicated person",
        image: boy3
    },
    {
        id: 4,
        name: 'Bharat Jain',
        title: 'Milaan Technologies',
        text: "Vaibhav has worked more than 4 months in Milaan Technologies, he is an excellent learner and harworking person",
        image: boy2
    },
    {
        id: 5,
        name: 'Chandni Jain',
        title: 'Milaan Technologies',
        text: "Vaibhav was the part of Data Mining team and had worked in field of ML and NLP. His performance was exception during the period.",
        image: girl2
    },
    {
        id: 6,
        name: 'Kahmira Mewara',
        title: 'LakeBrain Technolgies',
        text: "Vaibhav is a brilliant scholar and a dedicated person ! He is hardworking, motivated and has deep knowledge of the field.",
        image: girl1
    },
    {
        id: 7,
        name: 'Abhinav Sharma',
        title: 'We Code',
        text: "Vaibhav had worked in We Code as an intern in field of web development. He was honest and had good knowledge of the subject.",
        image: boy1
    },
    {
        id: 8,
        name: 'Vandana Singh',
        title: 'Tech Spark',
        text: "During his intern, Vaibhav had shown atmost honesty towards his duties. His work is really appreciable.",
        image: girl3
    },
    
]

